import { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { Icons, Collapse, CollapseRef } from 'ui-kit';
import { hash } from 'utils/string';

import { userContext } from 'contexts/UserContext';
import { Trans } from '@lingui/react/macro';
import { SUPPORT_LINKS } from 'config';
import styles from './Faq.module.scss';

export function Faq() {
  const collapseRef = useRef<CollapseRef>(null);
  const contentRef = useRef<HTMLUListElement>(null);
  const [lastHash, setLastHash] = useLocalStorage('fag:hash');
  const { t } = useTranslation('faq');
  const {
    user: { Groups = [] }
  } = useContext(userContext);

  const getContentHash = useCallback(() => {
    const content = contentRef.current?.innerHTML || '';
    return hash(content);
  }, []);

  useEffect(() => {
    const currentHash = getContentHash();
    if (currentHash !== lastHash) {
      collapseRef.current?.toggle();
    }
  }, [getContentHash, lastHash]);

  const saveHash = useCallback(() => {
    setLastHash(getContentHash());
  }, [getContentHash, setLastHash]);

  const isBYuser = useMemo(
    () => Groups.some(({ Country }) => Country === 'by'),
    [Groups]
  );

  return (
    <Collapse
      title={t('title')}
      icon={Icons.QuestionOutlined}
      ref={collapseRef}
      onCollapse={saveHash}
    >
      <ul className={styles.faq} ref={contentRef}>
        <li dangerouslySetInnerHTML={{ __html: t('payments') }} />
        <li dangerouslySetInnerHTML={{ __html: t('warranty') }} />
        <li dangerouslySetInnerHTML={{ __html: t('association') }} />
        {isBYuser && (
          <li>
            <Trans>
              Телеграмм чат технической поддержки{' '}
              <a href={SUPPORT_LINKS.TG}>@alivewaternewbot</a>
            </Trans>
          </li>
        )}
      </ul>
    </Collapse>
  );
}
